module.exports = __webpack_public_path__ + "b4d804b9352084b5f4cf3aea646825f2.svg";